function generateDto(id, limit, page, offPlatform) {
  const isOffPlatform =
    offPlatform !== null && offPlatform !== undefined ? offPlatform : undefined
  return {
    user: [id],
    include: ['position', 'employer', 'stage'],
    limit,
    page,
    isOffPlatform,
  }
}

function ApplicationsController($scope, CandidateApplicationApi, PositionApi) {
  $scope.paginationOptions = {
    limitOptions: [10, 20, 50],
    selectedLimit: 10,
  }

  $scope.pagination = {
    currentPage: 0,
    totalItems: 0,
  }

  $scope.applicationsPageChange = async () => {
    $scope.getApplications()
  }

  $scope.getApplications = async () => {
    const getCandidateApplicationDto = generateDto(
      $scope.candidate.id,
      $scope.paginationOptions.selectedLimit,
      $scope.pagination.currentPage
    )
    const {
      data: applicationStages,
    } = await CandidateApplicationApi.getApplicationStages()
    $scope.applicationStages = applicationStages
    const candidateApplications = await CandidateApplicationApi.getCandidateApplications(
      getCandidateApplicationDto
    )

    const candidateApplicationsCount = await CandidateApplicationApi.getApplicationsCount(
      $scope.candidate.id
    )

    if (candidateApplications.status === 200) {
      $scope.applications = candidateApplications.data
      if ($scope.applications.length <= 0) {
        $scope.showNoJobs = true
        $scope.mainAlert =
          'You will be able to track your applications on this page.'
      } else {
        $scope.showInfo = true
        $scope.totalApplications = candidateApplicationsCount
        $scope.pagination.totalItems = $scope.totalApplications
      }

      $scope.applications = formatApplications($scope.applications)
      $scope.$applyAsync()
    }
  }

  $scope.expandApplication = application => {
    application.expanded = !application.expanded
    $scope.getApplicationPositionDetails(application)
  }

  const formatApplications = applications => {
    $scope.count = {
      regularCustom: 0,
      specConnect: 0,
    }
    console.debug('formatApplications: initial state', applications)
    const formatted = applications.map(application => {
      if (application.employerLogo)
        application.employerPicture = `${process.env.PUBLIC_BUCKET_URL}/employers/${application.employerId}/logo/${application.employerLogo}`
      else application.employerPicture = `images/firm-logo-default.jpg`
      if (
        application.positionType === 'Regular' ||
        application.positionType === 'Custom'
      )
        $scope.count.regularCustom++
      else $scope.count.specConnect++
      application.substage = $scope.applicationStages.find(
        stage => stage.name === application.applicationStageName
      )
      console.debug('substage:', application.substage)
      application.stage =
        application.substage &&
        $scope.applicationStages.find(
          stage => stage.id === application.substage.parentId
        )

      console.debug('stage:', application.stage)
      if (application.stage.name === 'HIRED')
        application.liveStatus = 'Archived'
      else application.liveStatus = 'Live Jobs'
      application.locations = application.positionLocations.map(location =>
        $scope.locations.find(loc => location === loc.id)
      )
      application.legalPracticeAreas = application.positionPractices.map(
        practice =>
          $scope.legalPracticeAreas.find(
            legalPractice => practice.id === legalPractice.id
          )
      )
      application.contract = $scope.contracts.find(
        contract => contract.id === application.contractType
      )
      application.occupation = $scope.occupations.find(
        occupation => occupation.id === application.occupation
      )
      application.positionDescription = 'Loading...'
      return application
    })

    console.debug('formatApplications::formatted:', formatted)
    return formatted
  }

  $scope.getApplicationPositionDetails = async application => {
    const id = application.id
    const positionId = application.positionId
    const {data} = await PositionApi.getPositionById(positionId)
    const {description} = data
    const index = $scope.applications.findIndex(app => app.id === id)
    $scope.applications[index].positionDescription = description

    $scope.$applyAsync()
  }

  $scope.fetchApplicationActiveTab = (
    positionId,
    stageName,
    stageId,
    status
  ) => {
    let color = '#ffef00'
    if (stageName === 'HIRED' || status === 'Accepted') color = '#008000'
    else if (status === 'Rejected by LexStep') color = '#ffa500'
    else if (status === 'Employer Declined' || status === 'Candidate Withdrew')
      color = '#ff0000'
    var test = angular.element('#' + positionId + stageId)
    test.css('background', color)
    if (test.length > 0) {
      test[0].children[0].style.borderColor =
        color + ' ' + color + ' transparent transparent'
      test[0].children[0].style.boxShadow = '1.4px -1.4px 0px 0px ' + color
    }
  }

  $scope.getApplications()
}

ApplicationsController.$inject = [
  '$scope',
  'CandidateApplicationApi',
  'PositionApi',
]

export {ApplicationsController}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/applications/applications.ctrl.js